import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { deleteVideo, deleteVideos } from '../../services/VideoService';
import { Video, DeleteVideoRequest, DeleteVideosRequest } from '../../types/Videos';

type Result = UseMutationResult<Video, Error, DeleteVideoRequest>;

function useDeleteVideo(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(deleteVideo, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['videos'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

type MultiVideoResult = UseMutationResult<Video[], Error, DeleteVideosRequest>;

export function useDeleteVideos(successCb: () => void, failureCb: (error: string) => void): MultiVideoResult {
  const queryClient = useQueryClient();

  return useMutation(deleteVideos, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['videos'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useDeleteVideo;
